<template>
  <a class="boardListStyle"
     :class="data.oMenu.strMenuName"
     @click="boardDetailMove(data.oMenu.nMenuNum, data.oBoard.nBoardNum, data.oBoard.oAuthorizeAccessRead)"
  >
    <div class="infoBox clearfix" :class="boardReadCheck(data.oBoard.nBoardNum)">
      <div class="title clearfix">
        <!-- 지식인 글 여부 -->
        <span class=""
              v-if="data.oBoard && data.oBoard.oKnowledgeIn.bKnowledgeIn"
              :class="'iconKonw_'+data.oBoard.oKnowledgeIn.strKnowledgeInStatus">
          {{ data.oBoard.oKnowledgeIn.strKnowledgeInStatus | filterStrKnowledgeInStatusName }}
        </span>
        <!-- 게시글 제목  :href="'#'+data.oBoard.nBoardNum" -->
        <p>
          <span class="boardListNoticeTitle" v-if="data.oBoard.strAtclType === 'NOTICE' ">
            공지
          </span>
          <span v-if="data.oBoard.strRegionName">
            [{{ data.oBoard.strRegionName }}]
          </span>
          <span :class="{ bUserBlockY: (data.oUser.strBlockCode === 'Y') }">
            {{ data.oBoard.strBoardTitle }}
          </span>
        </p>
        <!-- 이미지 등록여부 -->
        <span class="iconPhoto"
              v-if="data.oBoard && data.oBoard.bHasImage"></span>

        <!-- 파일 등록여부 -->
        <span class="iconFile"
              v-if="data.oBoard && data.oBoard.bHasFile"></span>
      </div>
      <div class="info userPopupInfo">
        <!-- 사용자 정보 -->
        <span class="name"
              v-if="data.oUser && data.oUser.strNickName"
              @click.stop="userPopupToggleClass($event,'on')">
                    {{ data.oUser.strNickName }}
                    <board-user-popup :data.sync="data"/>
                </span>
        <!-- 게시글 등록일 -->
        <span class="time"
              v-if="data.oBoard && data.oBoard.strRegDate">
                    {{ data.oBoard.strRegDate | moment("YY.MM.DD") }}
                </span>

        <!-- 조회수 -->
        <span class="readcnt"
              v-if="data.oBoard && data.oBoard.nViewCnt">
                    {{ data.oBoard.nViewCnt | comma }}
                </span>

        <!-- 추천수 -->
        <span class="like" v-if="data.oBoard && data.oBoard.nRecomCnt">
                    {{ data.oBoard.nRecomCnt | comma }}
                </span>
      </div>
    </div>
    <!-- 댓글수 -->
    <div class="replyBox" v-if="data.oMenu.nMenuNum !== 9999">
      <strong v-if="data.oBoard">
        {{ data.oBoard.nReplyCnt | comma }}
      </strong>
      <span>댓글</span>
    </div>
  </a>
</template>

<script>
import BoardUserPopup from "@/components/boardUserPopup";

export default {
  name: 'boardListStyle',
  components: {BoardUserPopup},
  data() {
    return {
      // boardId: '',
    }
  },
  props: ['data'],
  // 계산된 속성
  computed: {},
  // 감시자
  watch: {},
  // $el 생성전
  created() {
  },
  // $el 생성후
  mounted() {
  },
  methods: {},
}
</script>
<style scoped>
.boardListStyle.FAQ {
  position: relative
}

.infoBox {
  float: left; /*padding-right: 50px;*/
  width: 100%;
}

.infoBox div.title a {
  float: left;
  font-size: 16px;
  letter-spacing: -1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: calc(100% - 120px);
  display: inline-block;
}

.infoBox div.title span.iconPhoto {
  float: left;
  background: url("../assets/images/icon-photo.png") center top 5px no-repeat;
  width: 15px;
  height: 23px;
  background-size: 15px 13px;
  display: inline-block;
  margin-left: 3px
}

.infoBox div.title span.iconFile {
  float: left;
  background: url("../assets/images/icon-file.png") center top 4px no-repeat;
  width: 13px;
  height: 23px;
  background-size: 13px 15px;
  display: inline-block;
  margin-left: 3px
}

.infoBox div.info {
  float: left;
  color: #737373;
  font-size: 12px;
  font-weight: 400;
}

.infoBox div.info span {
  position: relative;
  margin-right: 10px;
}

.infoBox div.info .name {
}

.infoBox div.info .time {
  padding-left: 7px;
}

.infoBox div.info .time:after {
  content: "";
  background-image: url("../assets/images/icon-time.png");
  width: 4px;
  height: 4px;
  background-size: 4px 4px;
  background-repeat: no-repeat;
  position: absolute;
  top: 6px;
  left: 0px
}

.infoBox div.info .readcnt {
  padding-left: 18px;
}

.infoBox div.info .readcnt:after {
  content: "";
  background-image: url("../assets/images/icon-readcnt.png");
  width: 15px;
  height: 9px;
  background-size: 15px 9px;
  background-repeat: no-repeat;
  position: absolute;
  top: 4px;
  left: 0px
}

.infoBox div.info .like {
  padding-left: 17px;
}

.infoBox div.info .like:after {
  content: "";
  background-image: url("../assets/images/icon-like.png");
  width: 14px;
  height: 12px;
  background-size: 14px 12px;
  background-repeat: no-repeat;
  position: absolute;
  top: 2px;
  left: 0px
}

.replyBox {
  position: absolute;
  right: 0;
  top: 0;
  width: 42px;
  height: 48px;
  background: #f2f2f2;
  text-align: center;
  border-radius: 5px;
}

.boardListStyle.FAQ .replyBox {
  top: -10px
}

.replyBox strong {
  color: #0086ff;
  display: block;
  font-size: 15px;
  font-weight: 600;
  padding-top: 2px;
}

.replyBox span {
}

.iconKonw_READY {
  float: left;
  background: url("../assets/images/icon_article_list_knowledge_on.png") center top 3px no-repeat;
  background-size: 13px 17px;
  background-position: center left;
  display: inline-block;
  margin-right: 8px;
  padding-left: 15px;
  font-size: 16px;
  letter-spacing: -1px;
  color: #4eba39;
}

.iconKonw_CHOICE {
  float: left;
  background: url("../assets/images/icon_article_list_knowledge_on.png") center top 3px no-repeat;
  background-position: center left;
  display: inline-block;
  margin-right: 8px;
  padding-left: 15px;
  font-size: 16px;
  letter-spacing: -1px;
  color: #4eba39;
}

.iconKonw_FINISH {
  float: left;
  background: url("../assets/images/icon_article_list_knowledge_off.png") center top 3px no-repeat;
  background-position: center left;
  display: inline-block;
  margin-right: 8px;
  padding-left: 15px;
  font-size: 16px;
  letter-spacing: -1px;
  color: #b3b3b3;
}

.iconKonw_EXPIRED {
  float: left;
  background: url("../assets/images/icon_article_list_knowledge_off.png") center top 3px no-repeat;
  background-position: center left;
  display: inline-block;
  margin-right: 8px;
  padding-left: 15px;
  font-size: 16px;
  letter-spacing: -1px;
  color: #b3b3b3;
}

</style>
